<template>
<div>
<AddDropRequest/>

</div>
</template>

<script>
import AddDropRequest from "../../components/academic/AddDropRequest.vue";


export default {
  components: {
   AddDropRequest
  },
  beforeCreate: function() {
        document.body.className = 'iner';
    },
  created() {
  }
};
</script>

<style scoped>


</style>